

































import { Component, Vue, Prop } from "vue-property-decorator";
import SearchForm from "@/components/inputs/SearchForm.vue";
import { USER_ME, UserMeData } from "@/graphql/query/user/me";

@Component({
  components: { SearchForm },
  apollo: {
    groupId: {
      query: USER_ME,
      update(data: UserMeData): string {
        return data.me.group.id;
      }
    }
  }
})
export default class Home extends Vue {
  @Prop(Number) target!: 0 | 1 | 2 | 3 | 4;
  groupId: string = "";

  search(token: string) {
    if (token) {
      this.$router.push({ name: "search-result", query: { q: token } });
    }
  }
}
